import { Component, input, Input, InputSignal, OnInit } from '@angular/core';
import { ApplicationAppEntityApplicationRead, ShipmentAppEntityShipmentRead } from '../../../../../openapi';
import {
  ApplicantPreviewComponent
} from '../../common/applicant-data-section/components/applicant-preview/applicant-preview.component';
import {
  ApplicationDataPreviewComponent
} from '../../common/application-data-section/components/application-data-preview/application-data-preview.component';
import { CommonModule, DatePipe } from '@angular/common';
import { DecisionDataPreviewComponent } from '../../common/decision-data-preview/decision-data-preview.component';
import { LabelComponent } from '../../../../../common/label/label.component';
import { ParcelsPreviewComponent } from '../../common/components/parcels/parcels-preview/parcels-preview.component';
import {
  AgreementsDataPreviewComponent
} from '../../common/agreements-data-section/components/agreements-data-preview/agreements-data-preview.component';
import {
  AttachmentsDataPreviewComponent
} from '../../common/attachments-data-section/components/attachments-data-preview/attachments-data-preview.component';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-opinion-on-issuing-a-decision-preview',
  standalone: true,
  imports: [
    ApplicantPreviewComponent,
    DatePipe,
    DecisionDataPreviewComponent,
    LabelComponent,
    CommonModule,
    ParcelsPreviewComponent,
    AgreementsDataPreviewComponent,
    AttachmentsDataPreviewComponent
  ],
  templateUrl: './opinion-on-issuing-a-decision-preview.component.html'
})
export class OpinionOnIssuingADecisionPreviewComponent implements OnInit {

  @Input()
  public expanded: boolean = true;

  public application: InputSignal<ApplicationAppEntityApplicationRead | null> = input<ApplicationAppEntityApplicationRead | null>(null);

  public shipments: InputSignal<ShipmentAppEntityShipmentRead[]> = input<ShipmentAppEntityShipmentRead[]>([]);

  public canPay: InputSignal<boolean> = input<boolean>(false);

  public applicationSubmittedTo = environment.applicationSubmittedTo;

  constructor() {
  }

  public ngOnInit(): void {
  }
}
